import {useCallback, useMemo, useRef} from "react";
import { Switch } from "@mui/material";
import AgGridCustomTable from "../../../../../../../util/component/AgGridCustomTable";
import {useTranslation} from "react-i18next";
import {AgGridReact} from "ag-grid-react";
import {CellValueChangedEvent, ColDef} from "ag-grid-community";
import {IGeneralTimeframe} from "../../../../models";
import CurrentTimeFrame from "./CurrentTimePicker";
import EditSaveButton from "./EditSaveButton";
import { IGeneralTimeframePanel } from "./types";
import {defaultColDef} from './config';
import { createGeneralTimeframe } from "../../../../RsDetail.actions";

const GeneralTimeframePanel = ({disabled, setDisabled, curTimeframe, setCurTimeframe}: IGeneralTimeframePanel) => {
    const {t} = useTranslation(["network", "translation"]);
    const gridRef = useRef<AgGridReact>(null);

    const handleChangeFrom = (newValue: any | null, secondValue: any) => {
        secondValue.setValue(newValue);
    };

    const handleChangeIsOpen = (newValue: any | null, secondValue: any) => {
        secondValue.setValue(newValue.target.checked);
    };

    const columnDefs = useMemo<ColDef[]>(() => [
        {
            field: 'dayOfWeek',
            headerName: t(`rsDetail.timeframe.table.dayOfWeek`),
            valueFormatter: (params) => t(`rsDetail.timeframe.dayOfWeek.${params.value}`)
        },
        {
            field: 'isOpen',
            headerName: t("rsDetail.timeframe.table.closeOpen"),
            cellRenderer: (p: any) => 
                <Switch disabled={disabled} onClick={(e: any) => {handleChangeIsOpen(e, p)}} checked={p.value} />,
        },
        {
            field: 'opening',
            headerName: t("rsDetail.timeframe.table.opening"),
            cellRenderer: (p: any) =>
                <CurrentTimeFrame p={p} disabled={disabled} handleChangeForm={handleChangeFrom} />,
        },
        {
            field: 'breakFrom',
            headerName: t("rsDetail.timeframe.table.breakFrom"),
            cellRenderer: (p: any) =>
                <CurrentTimeFrame p={p} disabled={disabled} handleChangeForm={handleChangeFrom} />,
        },
        {
            field: 'breakTo',
            headerName: t("rsDetail.timeframe.table.breakTo"),
            cellRenderer: (p: any) =>
                <CurrentTimeFrame p={p} disabled={disabled} handleChangeForm={handleChangeFrom} />,
        },
        {
            field: 'closing',
            headerName: t("rsDetail.timeframe.table.closing"),
            cellRenderer: (p: any) =>
                <CurrentTimeFrame p={p} disabled={disabled} handleChangeForm={handleChangeFrom} />,
        },
    ], [disabled]);

    const onCellValueChanged = useCallback((params: CellValueChangedEvent) => {
        let changedData = [params.data];
        const curTimeframeMapped= curTimeframe.map((x) => changedData[0].dayOfWeek === x.dayOfWeek ? changedData[0] : x);
        setCurTimeframe(curTimeframeMapped);
        gridRef.current!.api.applyTransaction({update: curTimeframeMapped});
    }, [curTimeframe]);

    return (
        <>
            <EditSaveButton<IGeneralTimeframe>
                disabled={disabled}
                setDisabled={setDisabled}
                setTimeframe={setCurTimeframe}
                timeframe={curTimeframe}
                timeframeReqField="generalTimeFrame"
                createTimeframe={createGeneralTimeframe}
                title={t("rsDetail.timeframe.tab.generic")}
            />
            <AgGridCustomTable
                gridRef={gridRef}
                rowData={curTimeframe}
                pagination={false}
                columnDefs={columnDefs}
                onCellValueChanged={onCellValueChanged}
                gridOptions={
                    {
                        defaultColDef,
                        onGridReady: (event) => {
                            event.api.sizeColumnsToFit()
                        }
                    }
                }
            />
        </>
    );
}

export default GeneralTimeframePanel;
